export const GRID_DEFAULTS = {
    columns: 12,
    rowHeight: 24,
    margin: {
        vertical: 24,
        horizontal: 24,
    },
    padding: {
        vertical: 0,
        horizontal: 0,
    },
};
//# sourceMappingURL=grid.js.map